var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import apiGateway from '@/api-gateway';
import { Component, Vue } from 'vue-property-decorator';
import ProjectList from '@/components/project-list/ProjectList.vue';
import { genProjectName } from '@/utils/string';
import Spinner from '@/components/Spinner.vue';
import SubFilter from '@/components/SubFilter.vue';
var MeetingAgenda = /** @class */ (function (_super) {
    __extends(MeetingAgenda, _super);
    function MeetingAgenda() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.projects = [];
        _this.pagination = { limit: 50 };
        _this.search = '';
        _this.loading = false;
        _this.totalRows = -1;
        _this.id_number = null;
        _this.programDropdown = {
            projectCategory: '',
            formatOptions: '',
            projectRegionCode: []
        };
        return _this;
    }
    MeetingAgenda.prototype.onSearchQueryChange = function (search) {
        return __awaiter(this, void 0, Promise, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.search = search;
                        this.pagination = { limit: 50 };
                        this.pagination.offset = 0;
                        _a = this;
                        return [4 /*yield*/, this.fetchProjects(this.pagination, this.search)];
                    case 1:
                        _a.projects = (_b.sent()).rows;
                        this.calculatePaginationParams(this.projects);
                        return [2 /*return*/];
                }
            });
        });
    };
    MeetingAgenda.prototype.outputValue = function (value) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.programDropdown.projectCategory = value.projectCategory;
                        this.programDropdown.formatOptions = value.formatOptions;
                        this.programDropdown.projectRegionCode = value.projectRegionCode;
                        return [4 /*yield*/, this.onSearchQueryChange(this.search)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MeetingAgenda.prototype.fetchProjects = function (pagination, search) {
        return __awaiter(this, void 0, Promise, function () {
            var subFilter, resp, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        subFilter = {
                            category: this.programDropdown.projectCategory,
                            format: this.programDropdown.formatOptions,
                            regional: this.programDropdown.projectRegionCode
                        };
                        return [4 /*yield*/, apiGateway.getProjectsBySubFilter(true, pagination, search, subFilter)];
                    case 1:
                        resp = _a.sent();
                        data = resp.data.rows.map(function (project) {
                            return __assign(__assign({}, project), { name: genProjectName(project) });
                        }) || [];
                        this.loading = false;
                        this.totalRows = resp.data.total;
                        return [2 /*return*/, { total: resp.data.total, rows: data }];
                }
            });
        });
    };
    MeetingAgenda.prototype.getMaxId = function (projects) {
        if (projects.length === 0)
            return;
        return projects.reduce(function (a, b) { return (a.id > b.id ? a : b); }).id;
    };
    MeetingAgenda.prototype.calculatePaginationParams = function (batch) {
        var batchMaxId = this.getMaxId(batch);
        this.pagination.cursor = batchMaxId ? batchMaxId : this.pagination.cursor;
        this.pagination.offset = batchMaxId ? 1 : (this.pagination.offset || 0) + 50;
    };
    MeetingAgenda.prototype.onScrollToBottom = function () {
        return __awaiter(this, void 0, Promise, function () {
            var newBatch;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if ((this.pagination.offset || 0) >= this.totalRows) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.fetchProjects(this.pagination, this.search)];
                    case 1:
                        newBatch = (_b.sent())
                            .rows;
                        (_a = this.projects).push.apply(_a, newBatch);
                        this.calculatePaginationParams(newBatch);
                        return [2 /*return*/];
                }
            });
        });
    };
    MeetingAgenda.prototype.created = function () {
        return __awaiter(this, void 0, Promise, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchProjects(this.pagination)];
                    case 1:
                        data = _a.sent();
                        this.projects = data.rows;
                        this.calculatePaginationParams(data.rows);
                        return [2 /*return*/];
                }
            });
        });
    };
    MeetingAgenda = __decorate([
        Component({
            components: {
                ProjectList: ProjectList,
                Spinner: Spinner,
                SubFilter: SubFilter
            }
        })
    ], MeetingAgenda);
    return MeetingAgenda;
}(Vue));
export default MeetingAgenda;
